import { createGeneralVideoProvider } from '../general';
import { seedanceConfigs } from './configs/seedance';

/**
 * Dimensio（jimeng.dimensio.cn）视频提供商
 *
 * - 提交：POST /v1/videos/generations
 * - 查询：GET /v1/videos/tasks/:taskId
 *
 * 创建响应：{ created, task_id, status: 'submitted' }
 * 查询响应：{ task_id, status, progress, result: { url }, requested_model, effective_model, credits_consumed }
 * 错误响应：{ code, message, data: null }
 */
export const dimensio = createGeneralVideoProvider({
    providerName: 'DIMENSIO',
    baseUrlEnv: 'DIMENSIO_BASE_URL',
    apiKeyEnv: 'DIMENSIO_API_KEY',
    debugEnv: 'DIMENSIO_DEBUG',
    statusMapping: {
        taskIdPath: 'task_id',
        statePath: 'status',
        success: ['completed'],
        failed: ['failed', 'blocked', 'cancelled', 'expired'],
        processing: ['submitted', 'queued', 'processing'],
        videoUrlPath: 'result.url',
        errorPath: 'error',
    },
    models: {
        ...seedanceConfigs,
    },
});
